var prodcat;

prodcat = prodcat || {};

(function ($) {
  var addAllToBagFormatter = {
    setup: function (context) {
      var self = this;

      self.$modules = $('.js-add-all-to-bag-formatter', context);
      self.init();
    },
    init: function () {
      var self = this;
      var $module = $();

      self.$modules.each(function () {
        $module = $(this);

        self.getDom($module);
        self.calculatePrice($module);
        self.updateLabel($module);
        self.setupAddAllToBag($module);
      });
    },
    getDom: function ($module) {
      var $local = $module;

      $local.nodes = {};
      $local.nodes.cta = $('.js-add-all-to-bag-formatter-cta', $local);
      $local.nodes.ctaBtn = $('.js-elc-button', $local.nodes.cta);
      $local.nodes.content = $('.js-add-all-to-bag-formatter-content', $local);
      $local.nodes.productBriefs = $('.js-product-brief', $local.nodes.content);
      $local.config = {};
      $local.config.allPrice = '';

      this.saveDom($local);
    },
    saveDom: function ($local) {
      var self = this;

      self.$nodes = $local.nodes;
      self.$cta = $local.nodes.cta;
      self.$ctaBtn = $local.nodes.ctaBtn;
      self.$content = $local.nodes.content;
      self.$productBriefs = $local.nodes.productBriefs;
      self.config = $local.config;
      self.allPrice = $local.config.allPrice;
    },
    calculatePrice: function () {
      var self = this;
      var prices = [];
      var overlayPrice;
      var totalPrice;

      self.$productBriefs.each(function () {
        var skuId = $(this).attr('data-sku-base-id');
        var formattedPrice;
        var pricewithTax;

        totalPrice = Drupal.settings.display_totalprice_withtax
          ? Drupal.settings.display_totalprice_withtax
          : false;
        if (totalPrice) {
          formattedPrice = prodcat.data.getSku(skuId).formattedPrice;
          pricewithTax = parseFloat(formattedPrice.replace(/\$|,/gu, '.'));
          prices.push(pricewithTax);
        } else {
          prices.push(prodcat.data.getSku(skuId).PRICE);
        }
      });
      overlayPrice = Drupal.settings.trending_look_overlay_price
        ? Drupal.settings.trending_look_overlay_price
        : false;
      if (overlayPrice) {
        self.allPrice = prices.reduce((price1, price2) => price1 + price2, 0);
      }
      self.allPrice = prices.reduce((price1, price2) => price1 + price2, 0).toFixed(2);
    },
    updateLabel: function () {
      var self = this;
      var $labelInput = self.$ctaBtn.find('span');

      if ($labelInput.length) {
        self.$ctaBtn.html($labelInput.html().replace('::count::', self.$productBriefs.length).replace('::price::', self.allPrice));
      }
    },
    setupAddAllToBag: function () {
      var self = this;
      var allSkuIds = [];

      self.$productBriefs.each(function () {
        var $productBrief = $(this);
        var $shadeSelected = $productBrief.find('.js-product-brief-shades-item-link.selected');
        var $targetSkuElement = $shadeSelected.length > 0 ? $shadeSelected : $productBrief;

        allSkuIds.push($targetSkuElement.attr('data-sku-base-id'));
      });

      self.$ctaBtn.attr('data-sku-base-id', allSkuIds.join(', ')).addClass('product-add-all-to-bag js-product-add-all-to-bag');
    },
    updateAddAllToBag: function () {
      var self = this;
      var skus = [];
      var addToBagSkus = [];
      var thisSkuBaseId = '';
      var thisSkuData;

      if (!self.$productBriefs) {
        return;
      }

      self.$productBriefs.each(function () {
        thisSkuBaseId = $(this).data().skuBaseId;
        thisSkuData = prodcat.data.getSku(thisSkuBaseId);

        if (thisSkuData.INVENTORY_STATUS === 7 || thisSkuData.INVENTORY_STATUS === 2 || thisSkuData.INVENTORY_STATUS === 3) {
          return;
        }
        skus.push($(this).data().skuBaseId);
        addToBagSkus = skus.join(', ');
        self.$ctaBtn.attr('data-sku-base-id', addToBagSkus);
      });
    }
  };

  Drupal.behaviors.addAllToBagFormatterV1 = {
    $modules: $(),
    $nodes: $(),
    $cta: $(),
    $ctaBtn: $(),
    $content: $(),
    $productBriefs: $(),
    config: {},
    allPrice: '',
    attach: function (context) {
      addAllToBagFormatter.setup(context);
    }
  };
  $(document).on('product.skuSelect', '.js-product-ui', function () {
    addAllToBagFormatter.updateAddAllToBag();
  });
})(jQuery);
